import { motion } from "framer-motion";

const Loader = () => {
  return (
    <div className="flex flex-col justify-center items-center w-full h-screen bg-white dark:bg-gray-900">
      
      {/* Logo animé */}
      <motion.img
        src="/logo.png"
        alt="Logo"
        className="w-24 h-24 mb-6"
        initial={{ y: 0 }}
        animate={{ y: [0, -10, 0] }}
        transition={{ duration: 1.5, repeat: Infinity }}
      />

      {/* Texte animé */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, repeat: Infinity, repeatType: "reverse" }}
        className="font-semibold text-gray-600 dark:text-gray-300"
      >
        Chargement en cours...
      </motion.p>
    </div>
  );
};

export default Loader;
